import Vue from 'vue'
import App from './App.vue'
import VueFullPage from 'vue-fullpage.js'
import Toasted from 'vue-toasted';
 
Vue.config.productionTip = false

Vue.use(Toasted, {
  singleton: true,
  position: 'top-center',
  duration: 3000
})
Vue.use(VueFullPage);

Vue.filter('spaces', function (value) {
  return value.split(' ').join('');
})

new Vue({
  el: '#app',
  render: h => h(App)
});
